export const NEWS_PAGE_SIZE = 6 as const;
